<template>
  <div
    class="bg-white dark:bg-gray-800 rounded-xl border-2 p-6 hover:shadow-md transition-all"
    :class="
      isNowPlaying
        ? 'border-green-400 dark:border-green-500 bg-green-50/40 dark:bg-green-900/20 ring-2 ring-green-300 dark:ring-green-500'
        : 'border-gray-200 dark:border-gray-700'
    "
  >
    <div class="results-card-layout">
      <div class="results-card-rank">
        <div
          class="w-12 h-12 sm:w-16 sm:h-16 rounded-full flex items-center justify-center font-bold text-xl text-white"
          :class="isNowPlaying ? 'bg-green-500 dark:bg-green-600 animate-pulse' : 'bg-teal-600 dark:bg-teal-700'"
        >
          <i v-if="isNowPlaying" class="pi pi-microphone text-2xl"></i>
          <span v-else>{{ queueNumber }}</span>
        </div>
      </div>

      <div class="results-card-info min-w-0">
        <h3 class="text-xl font-semibold text-gray-900 dark:text-white">
          {{ entry.song?.title || "Unknown" }}
        </h3>
        <p v-if="entry.song?.author" class="text-gray-600 dark:text-gray-400 text-sm">
          {{ entry.song.author }}
        </p>
      </div>

      <div v-if="entry.performerName" class="results-card-votes text-center">
        <div class="flex flex-col items-center gap-0.5">
          <i class="pi pi-user text-teal-500 text-xl"></i>
          <span class="text-base font-oswald tracking-wide text-gray-900 dark:text-white leading-tight">
            {{ entry.performerName }}
          </span>
          <span class="text-xs text-gray-500 dark:text-gray-400">performer</span>
        </div>
      </div>

      <div v-if="showAdminActions" class="results-card-button flex flex-col gap-2">
        <button
          v-if="isNowPlaying"
          class="px-4 py-2 bg-teal-600 hover:bg-teal-700 text-white rounded-lg transition-colors text-sm font-medium flex items-center gap-2 w-full sm:w-auto justify-center"
          @click="$emit('mark-performed', entry)"
        >
          <i class="pi pi-check-circle"></i>
          Mark Performed
        </button>
        <button
          v-else
          :disabled="disableStart"
          class="px-4 py-2 bg-teal-600 hover:bg-teal-700 disabled:opacity-50 text-white rounded-lg transition-colors text-sm font-medium flex items-center gap-2 w-full sm:w-auto justify-center"
          @click="$emit('start-song', entry)"
        >
          <i class="pi pi-play"></i>
          Start song
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.results-card-layout {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  grid-template-areas:
    "rank info votes"
    "button button button";
  gap: 0.5rem 1rem;
  align-items: center;
}
.results-card-rank   { grid-area: rank; }
.results-card-info   { grid-area: info; }
.results-card-votes  { grid-area: votes; }
.results-card-button { grid-area: button; }

@media (min-width: 500px) {
  .results-card-layout {
    grid-template-columns: auto minmax(0, 1fr) auto auto;
    grid-template-areas: "rank info votes button";
  }
}
</style>

<script>
export default {
  name: "KaraokeQueueRow",
  props: {
    entry: { type: Object, required: true },
    queueNumber: { type: Number, default: 0 },
    isNowPlaying: { type: Boolean, default: false },
    showAdminActions: { type: Boolean, default: false },
    disableStart: { type: Boolean, default: false }
  },
  emits: ["start-song", "mark-performed"]
};
</script>
